import { classes } from 'constants'
import { mq } from 'utilities/breakpoints'

class InfoMower {
    constructor(containers) {
        this.onResizeToMobile = this.onResizeToMobile.bind(this)
        this.infoStart = containers[0]
        this.infoEnd = containers[1]

        this.mediaMobileBreakpoint = window.matchMedia(mq['SM_ONLY'])
        this.mediaMobileBreakpoint.addListener(this.onResizeToMobile)
    }

    onResizeToMobile() {
        if (this.mediaMobileBreakpoint.matches) {
            this.fadeInStartContainer()
            this.fadeInEndContainer()
        }
    }

    fadeOutStartContainer() {
        this.infoStart.classList.add(classes.HIDDEN)
    }
    fadeOutEndContainer() {
        this.infoEnd.classList.add(classes.HIDDEN)
    }

    fadeInStartContainer() {
        this.infoStart.classList.remove(classes.HIDDEN)
    }

    fadeInEndContainer() {
        this.infoEnd.classList.remove(classes.HIDDEN)
    }
}

export default InfoMower
